import { api } from 'API/axios';
import { IPersonalDetailsReqAttach } from 'Interfaces/updatePersonalDetails';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/newRequest';

export interface IRequestsData {
  fieldAttachmentsData: IRequestsFieldData[];
  note: string;
  phoneNumber: string;
  phonePrefix: string;
  type: number;
  id?: number;
  requestDataJson?: any;
  internetReqNum?: number;
}

export interface IRequestsFieldData {
  fieldId: string;
  attachments: { [fileName: string]: File };
}

export interface IUploadFileList {
  isRequired: boolean;
  requiredWith?: number[];
  requiredFieldGroupId?: number;
  name: string;
  id: string;
}
export interface IFormMetaData {
  formName: string;
  attachments: IUploadFileList[];
}

export const createRequest = async (body: any) => {
  const newRequest = await api.post(addImposterToUrl(baseUrl, true), body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  if (newRequest) {
    return newRequest;
  }
};

export const getRequestFields = async (
  reqSubTypeId: number,
  reqAttachSchema?: IPersonalDetailsReqAttach
) => {
  const query = reqSubTypeId
    ? `?reqSubTypeId=${reqSubTypeId}${
        reqAttachSchema
          ? `&addresses=${reqAttachSchema.addresses}&familyMembers=${
              reqAttachSchema.familyMembers
            }${
              reqAttachSchema.maritalStatus
                ? `&maritalStatus=${reqAttachSchema.maritalStatus}`
                : ''
            }`
          : ''
      }`
    : '';

  const res = await api.get<IFormMetaData>(
    addImposterToUrl(baseUrl + '/formMetaData' + query, false)
  );

  if (res.data) {
    return res.data;
  }
};
